import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogClose } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Divider } from '@/components/divider'
import RulesDialogHeader from '../dialog-header/rules-dialog-header'
import { Icons } from '@/theme/Images'
import PropTypes from 'prop-types'

const ConfirmationDialog = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose} className="w-[20px]">
      <DialogContent className="w-[480px] h-[221px]">
        <DialogHeader>
          <RulesDialogHeader
            title="Close without saving"
            description="Are you sure you close without saving? Any changes will be lost."
            icon={Icons.deactivateRule}
          />
        </DialogHeader>

        <div className="w-[111%] ml-[-23px]">
          <Divider />
        </div>

        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="w-full md:w-[210px] h-[44px] mb-[-6px] text-[#344054]">
              Back
            </Button>
          </DialogClose>

          <Button
            type="button"
            className="w-full text-[#FFFFFF] md:w-[210px] h-[44px] mb-[-6px] bg-[#B42318] hover:bg-[#fc6a60] focus:bg-[#B42318]"
            onClick={onConfirm}
          >
            Close without saving
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmationDialog

ConfirmationDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}
